"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.destroyModel = exports.fetchCentral = exports.saveCentral = exports.find = exports.sendNewGaiaUrl = void 0;

var _qs = require("qs");

var _config = require("./config");

var sendNewGaiaUrl =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(gaiaURL) {
    var _ref2, apiServer, url, data, response, _ref3, success, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = (0, _config.getConfig)(), apiServer = _ref2.apiServer;
            url = "".concat(apiServer, "/radiks/models/crawl"); // console.log(url, gaiaURL);

            data = {
              gaiaURL: gaiaURL
            };
            _context.next = 5;
            return fetch(url, {
              method: 'POST',
              body: JSON.stringify(data),
              headers: new Headers({
                'Content-Type': 'application/json'
              })
            });

          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.json();

          case 8:
            _ref3 = _context.sent;
            success = _ref3.success;
            message = _ref3.message;

            if (success) {
              _context.next = 13;
              break;
            }

            throw new Error("Error when saving model: '".concat(message, "'"));

          case 13:
            return _context.abrupt("return", success);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendNewGaiaUrl(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.sendNewGaiaUrl = sendNewGaiaUrl;

var find =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(query) {
    var _ref5, apiServer, queryString, url, response, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref5 = (0, _config.getConfig)(), apiServer = _ref5.apiServer;
            queryString = (0, _qs.stringify)(query, {
              arrayFormat: 'brackets',
              encode: false
            });
            url = "".concat(apiServer, "/radiks/models/find?").concat(queryString);
            _context2.next = 5;
            return fetch(url);

          case 5:
            response = _context2.sent;
            _context2.next = 8;
            return response.json();

          case 8:
            data = _context2.sent;
            return _context2.abrupt("return", data);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function find(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

exports.find = find;

var saveCentral =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(data) {
    var _ref7, apiServer, url, response, _ref8, success;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _ref7 = (0, _config.getConfig)(), apiServer = _ref7.apiServer;
            url = "".concat(apiServer, "/radiks/central");
            _context3.next = 4;
            return fetch(url, {
              method: 'POST',
              body: JSON.stringify(data),
              headers: new Headers({
                'Content-Type': 'application/json'
              })
            });

          case 4:
            response = _context3.sent;
            _context3.next = 7;
            return response.json();

          case 7:
            _ref8 = _context3.sent;
            success = _ref8.success;
            return _context3.abrupt("return", success);

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function saveCentral(_x3) {
    return _ref6.apply(this, arguments);
  };
}();

exports.saveCentral = saveCentral;

var fetchCentral =
/*#__PURE__*/
function () {
  var _ref9 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(key, username, signature) {
    var _ref10, apiServer, queryString, url, response, value;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref10 = (0, _config.getConfig)(), apiServer = _ref10.apiServer;
            queryString = (0, _qs.stringify)({
              username: username,
              signature: signature
            });
            url = "".concat(apiServer, "/radiks/central/").concat(key, "?").concat(queryString);
            _context4.next = 5;
            return fetch(url);

          case 5:
            response = _context4.sent;
            _context4.next = 8;
            return response.json();

          case 8:
            value = _context4.sent;
            return _context4.abrupt("return", value);

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchCentral(_x4, _x5, _x6) {
    return _ref9.apply(this, arguments);
  };
}();

exports.fetchCentral = fetchCentral;

var destroyModel =
/*#__PURE__*/
function () {
  var _ref11 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(model) {
    var _ref12, apiServer, queryString, url, response, data;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _ref12 = (0, _config.getConfig)(), apiServer = _ref12.apiServer;
            queryString = (0, _qs.stringify)({
              signature: model.attrs.radiksSignature
            });
            url = "".concat(apiServer, "/radiks/models/").concat(model._id, "?").concat(queryString);
            _context5.next = 5;
            return fetch(url, {
              method: 'DELETE'
            });

          case 5:
            response = _context5.sent;
            _context5.next = 8;
            return response.json();

          case 8:
            data = _context5.sent;
            console.log(data);
            return _context5.abrupt("return", data.success);

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function destroyModel(_x7) {
    return _ref11.apply(this, arguments);
  };
}();

exports.destroyModel = destroyModel;